import axios from 'axios'
import router from '../router'

export default ({
    namespaced: true,
    state: {
        token: null,
        user: null,
        errors: null,
        messages: null
    },

    getters:{
        authenticated(state){
            return state.token && state.user
        },
        user(state){
            return state.user
        },
        errors(state){
            return state.errors
        },
        messages(state){
            return state.messages
        },
        isSanctioned(state){
            return state.user?.sancion
        },

    },

    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
        },
        SET_USER(state, data) {
            state.user = data
        },
        SET_ERRORS(state, data) {
            state.errors = data
        },
        SET_MESSAGES(state, data) {
            state.messages = data
        }
    },

    actions: {
        async signUp({dispatch}, credentials) {
            try {
                let response = await axios.post('auth/register', credentials)
                router.replace({
                    name: 'auth.login'
                })
                return response.data.message
            } catch (e) {
                dispatch('setAuthErrors', e.response.data)
            }
        },

        async signIn({dispatch}, credentials) {
            try {
                let response = await axios.post('auth/login', credentials)
                return dispatch('attempt', response.data.token )
            } catch (e) {
                dispatch('setAuthErrors', e.response.data)
            }
        },
        
        async recover({commit, dispatch}, credentials) {
            try {
                const response = await axios.post('auth/recover', credentials)
                commit('SET_MESSAGES', response.data.message)
                return response.data.message
            } catch (e) {
                dispatch('setAuthErrors', e.response.data)
            }
        },

        async attempt ({commit, dispatch, state}, token) {
            if ( token ) {
                commit('SET_TOKEN', token)
            }
            if ( !state.token ) {
                return
            }
            try {
                let response = await axios.get('auth/profile')
                commit('SET_USER', response.data)
                dispatch('accountStatus/getAccountStatus', null, { root: true } )
                dispatch('accountStatus/getUnpaidPeriods', null, { root: true } )
                router.replace({
                    name: 'home'
                })

            } catch (e) {
                // let response = await axios.get('email/resend', e.response.data)
                commit('SET_TOKEN', null)
                commit('SET_USER', null)
                dispatch('setAuthErrors', e.response.data)
                router.go(-1)
            }
        },
        
        async updateUser({commit, dispatch}, data) {
            try {
                let response = await axios.put('profile', data)
                commit('SET_MESSAGES', response.data.message)
                return response.data.message
            } catch (e) {
                dispatch('setAuthErrors', e.response.data)
            }
        },

        signOut({commit}) {
            return axios.post('auth/logout').then(() => {
                commit('SET_TOKEN', null)
                commit('SET_USER', null)
            })
        },

        setAuthErrors({commit, dispatch}, message) {
            commit('SET_ERRORS', message)
            setTimeout(() =>
                dispatch('clearAuthErrors'),
            3000);
        },

        setAuthMessage({commit, dispatch}, message) {
            commit('SET_MESSAGES', message)
            setTimeout(() =>
                dispatch('clearAuthMessages'),
            3000);
        },

        clearAuthErrors({commit}) {
            commit('SET_ERRORS', null)
        },

        clearAuthMessages({commit}) {
            commit('SET_MESSAGES', null)
        }

    }
})
